import { getItem, setItem } from "owa-local-storage";
import isPopout from "owa-popout-v2/lib/utils/isPopout";
import isDeepLink from "owa-url/lib/isDeepLink";
import { MINIMUM_COPILOT_CHAT_DRAWER_WIDTH } from "./copilotChatDrawerConstants";

const LOCAL_STORAGE_KEY = "CopilotChatDrawerUserPreferredWidth";

export type CopilotChatDrawerWidthBucket = "Default" | "Customized" | "CustomizedMinimum";

export function saveCopilotChatDrawerWidth(targetWindow: Window, width: number): void {
    if (isPopout(targetWindow) || isDeepLink()) {
        return;
    }
    try {
        setItem(window, LOCAL_STORAGE_KEY, width.toString());
    }
    catch {
        // Silently fail if localStorage is unavailable
    }
}

export function getSavedCopilotChatDrawerWidth(): number | null {
    try {
        const stored = getItem(window, LOCAL_STORAGE_KEY);
        if (stored === null) {
            return null;
        }
        const width = parseFloat(stored);
        return isNaN(width) ? null : width;
    }
    catch {
        return null;
    }
}

/**
 * Classify the user's saved drawer width into a telemetry bucket:
 *  - 'Default'           — never customized (no localStorage value)
 *  - 'CustomizedMinimum' — customized but at/below the floor (380px),
 *                          e.g. dragged to min or used the collapse button
 *  - 'Customized'        — customized to a value above the minimum
 */
export function getCopilotChatDrawerWidthBucket(): CopilotChatDrawerWidthBucket {
    const saved = getSavedCopilotChatDrawerWidth();
    if (saved === null) {
        return "Default";
    }
    if (saved <= MINIMUM_COPILOT_CHAT_DRAWER_WIDTH) {
        return "CustomizedMinimum";
    }
    return "Customized";
}
